var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadiobutton01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Radiobutton-01__Icn/40px/Radiobutton-01",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,12 C24.418278,12 28,15.581722 28,20 C28,24.418278 24.418278,28 20,28 C15.581722,28 12,24.418278 12,20 C12,15.581722 15.581722,12 20,12 Z M20,14 C16.6862915,14 14,16.6862915 14,20 C14,23.3137085 16.6862915,26 20,26 C23.3137085,26 26,23.3137085 26,20 C26,16.6862915 23.3137085,14 20,14 Z",
    id: ".._.._src_svg_Icn_40px_Radiobutton-01__Oval-Copy-2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiobutton01);
export default __webpack_public_path__ + "static/media/Radiobutton-01.b784792619e179cf145303e0e910ae72.svg";
export { ForwardRef as ReactComponent };